module.exports = function (element) {
    function markBlock(el) {
        var node = $(el);
        var block = $('.js-random-block');
        var url = $(el).data('url')

        node.on({
            click: function () {
                $.post(url, function (data) {
                    block.empty();
                    for (let i = 0; i < data.result.length; i++) {
                        block.append('<div class="wallpaper__random__items__item">'
                            + '<a href="' + data.result[i].url + '">'
                            + '<img src="' + data.result[i].img + '" width="120" height="80" alt="" border="0">'
                            + '</a></div>');
                    }

                    gtag('event', 'random_refresh', {
                        'event_category': 'random'
                    });
                }, 'json');

                return false;
            }
        });
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    markBlock(element);
};
